import { ComponentType } from "react";
import { ClauseInfoApp, HomeApp, SuggestionApp } from "../pages";
import { ApplicationType } from "../types/enums";

export const AppsComponents: Record<ApplicationType, ComponentType<any>> = {
  [ApplicationType.HOME_APP]: HomeApp,
  [ApplicationType.SUGGESTION_APP]: SuggestionApp,
  [ApplicationType.CLAUSE_INFO_APP]: ClauseInfoApp,
};
